export default __webpack_public_path__ + "static/generative-border-dark-199f960598de2407085928a5eb7b8d7b80925c54c882cba9660a0c3f1e35dabd.png";